import { AsyncPipe } from "@angular/common";
import {
    Component,
    Input,
    OnInit,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { CheckboxComponent } from "@components/checkbox/checkbox.component";
import { TextareaComponent } from "@components/textarea/textarea.component";
import { TogglePanelComponent } from "@components/toggle-panel/toggle-panel.component";
import { Observable } from "rxjs";
import { Kontrakt } from "../../models/kontrakt-models";
import { AvtalMediatorService } from "../../services/avtal-mediator.service";
import { KontraktMediatorService } from "../../services/kontrakt-mediator.service";

@Component({
    selector: "rask-kontrakt-anteckningar",
    templateUrl: "./kontrakt-anteckningar.component.html",
    styleUrls: ["./kontrakt-anteckningar.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TogglePanelComponent,
        TextareaComponent,
        CheckboxComponent,
        AsyncPipe,
        FormsModule
    ]
})
export class KontraktAnteckningarComponent implements OnInit {
    @Input() readonly = false;
    protected kontrakt$: Observable<Kontrakt>;

    private readonly avtalMediatorService = inject(AvtalMediatorService);
    private readonly kontraktMediatorService = inject(KontraktMediatorService);

    protected get isCvk() {
        return this.avtalMediatorService.avtal?.isCvk;
    }

    ngOnInit(): void {
        this.kontrakt$ = this.kontraktMediatorService.kontrakt$;
    }

    protected onChange(kontrakt: Kontrakt) {
        this.kontraktMediatorService.updateKontrakt(kontrakt);
    }
}
